import React, { FC } from 'react';
import RatesListItem from './RatesListItem/RatesListItem';
import getSymbolFromCurrency from 'currency-symbol-map';
import { IRates } from '../../../../../interfaces/professional/Professional';

interface Props {
  items: Array<IRates>;
  itemDescriptionClassName?: string;
}

const RatesList: FC<Props> = ({ items, itemDescriptionClassName }) => {
  const itemsList = items.map((item, index) => (
    <RatesListItem
      key={index}
      {...item}
      currency={getSymbolFromCurrency(item.currency) || item.currency}
      itemDescriptionClassName={itemDescriptionClassName}
    />
  ));

  return <ul>{itemsList}</ul>;
};

export default RatesList;
